module.exports = __webpack_public_path__ + "static/media/verisign-dark.1f0c2c56.svg";